import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import {
  OnboardingMultiDocumentsResponse,
  OnboardingStoreType,
  OracleOnboardingMultiDocumentSectionKey
} from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';
import { fetchMultiDocuments } from './onboarding-multi-document-api';

export const multiDocumentsQueryKey = (
  company: string,
  store: OnboardingStoreType,
  sectionKey: OracleOnboardingMultiDocumentSectionKey
): string[] => ['onboardingMultiDocuments', company, sectionKey, store];

export const useMultiDocuments = (
  company: string,
  store: OnboardingStoreType,
  sectionKey: OracleOnboardingMultiDocumentSectionKey
): UseQueryResult<OnboardingMultiDocumentsResponse> =>
  useQuery({
    queryKey: multiDocumentsQueryKey(company, store, sectionKey),
    queryFn: () => fetchMultiDocuments({ company, store, sectionKey }),
    enabled: Boolean(company)
  });

// Refetches one section's list in one store.
export const useInvalidateMultiDocuments = () => {
  const queryClient = useQueryClient();
  return (
    company: string,
    store: OnboardingStoreType,
    sectionKey: OracleOnboardingMultiDocumentSectionKey
  ): Promise<void> =>
    queryClient.invalidateQueries({
      queryKey: multiDocumentsQueryKey(company, store, sectionKey)
    });
};
